module.exports = __webpack_public_path__ + "static/media/tn.41bc7070.svg";